import { AfterViewInit, OnDestroy, ViewEncapsulation, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { Component, OnInit, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import { Subscription, BehaviorSubject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-tickers-table',
  templateUrl: './tickers-table.component.html',
  styleUrls: ['./tickers-table.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TickersTableComponent implements OnInit, AfterViewInit, OnDestroy {
  public ColumnMode = ColumnMode.force;
  public SelectionType = SelectionType.single;
  @Input('search') search: FormControl = null;
  @Input('rows') row_data: BehaviorSubject<any[]>;
  @Input('action') action: boolean = false;
  @Input('type') public type: 'stock' | 'crypto';
  private rows_subcription: Subscription;
  public temp: Array<object> = [];
  public rows: Array<object> = [];
  private search_subcription: Subscription;
  public columns = [
    { prop: 'companyName', name: 'Company' },
    { prop: 'price', name: 'Price' },
    { prop: 'volume', name: 'Volume' },
    { prop: 'percentageChange', name: '% Change' },
    { prop: 'sentiment', name: 'Sentiment' },
    { prop: 'technical', name: 'Technical' },
    { prop: 'fundamental', name: 'Fundamental' },
    { prop: 'valuation', name: 'Valuation' },
    { prop: 'macro', name: 'Macro' }
  ];
  @Output() rowSelect = new EventEmitter();
  @Output() deleteRow = new EventEmitter();
  @Output() showDetails = new EventEmitter();
  constructor(private _modalService: NgbModal, private changeDetector: ChangeDetectorRef) {

  }

  ngOnInit(): void {
    this.temp = [];
    this.rows = [];
  }

  ngAfterViewInit(): void {
    if(this.search){
      this.search_subcription = this.search.valueChanges.subscribe((value)=>{
        if(value){
          this.updateFilter(value);
        }
      });
    }

    this.rows_subcription = this.row_data.subscribe((rows:any)=>{
      if(rows){
        setTimeout(() => {
          this.rows = rows;
          this.temp = this.rows;
          this.changeDetector.detectChanges();
          if(this.search.value){
            this.updateFilter(this.search.value);
          }
        }, 300);
      }
    });
  }

  onSelect($event){
    if(!this.action){
      this.rowSelect.emit($event.selected[0]);
      this.changeDetector.detectChanges();
    }
  }

  updateFilter(val: any) {
    const value = val.toString().toLowerCase().trim();
    // get the amount of columns in the table
    const count = this.columns.length;
    // get the key names of each column in the dataset
    const keys = Object.keys(this.temp[0]);
    // assign filtered matches to the active datatable
    this.rows = this.temp.filter(item => {
      // iterate through each row's column data
      for (let i = 0; i < count; i++) {
        // check for a match
        if (
          (item[keys[i]] &&
            item[keys[i]]
              .toString()
              .toLowerCase()
              .indexOf(value) !== -1) ||
          !value
        ) {
          // found match, return true to add to result set
          return true;
        }
      }
    });

    // Whenever the filter changes, always go back to the first page
    // this.table.offset = 0;
  }

  ngOnDestroy(){
    this.rows_subcription.unsubscribe();
    this.search_subcription.unsubscribe();
  }

  deleteTicker(row, modalRef){
    this._modalService.open(modalRef).result.then((result)=>{
      this.deleteRow.emit(row);
      this.changeDetector.detectChanges();
    });
  }

  ViewDetail(row){
    this.showDetails.emit(row);
    this.changeDetector.detectChanges();
  }

  emptyClickHandler(btnElement){
    btnElement && btnElement.parentElement && btnElement.parentElement.parentElement &&
         btnElement.parentElement.parentElement.blur();
  }

  onActivate(event) {
    console.log('Activate Event', event);
  }

}
